export default __webpack_public_path__ + "static/media/mgconstrucciones.be12a656.png";